import * as TYPES from "./_types";

export default {

  reload_page: () => ({
    type: TYPES.RELOAD_PAGE,
    payload: null
  }),

  set_current_product: (content = {}) => ({
    type: TYPES.UPDATE_CURRENT_PRODUCT,
    payload: content
  }),

  update_product_list: (content = []) => ({
    type: TYPES.UPDATE_PRODUCT_LIST,
    payload: content
  }),

  update_categories: (content = []) => ({
    type: TYPES.UPDATE_CATEGORIES,
    payload: content
  }),

  add_product_to_cart: (content = {}) => ({
    type: TYPES.ADD_TO_CART,
    payload: content
  }),

  remove_cart_item: (handle) => ({
    type: TYPES.REMOVE_FROM_CART,
    payload: handle
  }),

  set_cart_item_quantity: (content = {}) => ({
    type: TYPES.UPDATE_CART_ITEM,
    payload: content
  }),

  update_cart: (content = []) => ({
    type: TYPES.UPDATE_CART,
    payload: content
  })

}
